import React, { FC, useState } from 'react';
import { useGetProgramMasterData } from 'src/api/mutations/useGetProgramMasterData';
import './EnergyLevelStep.scss';
import { ReactComponent as FluctuatesIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/fluctuates.svg';
import { ReactComponent as Often_highIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/often_high.svg';
import { ReactComponent as Often_lowIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/often_low.svg';

interface EnergyLevelStepProps {
  onBack?: () => void;
  onNext?: () => void;
  clientName?: string;
  value?: string;
  onChange?: (val: string) => void;
}

const iconMapping: Record<string, React.ReactNode> = {
  often_low: <Often_lowIcon />,
  fluctuates: <FluctuatesIcon />,
  often_high: <Often_highIcon />,
};

// What's {nameDisplay} baseline energy level?
export const EnergyLevelStep: FC<EnergyLevelStepProps> = ({
  onNext,
  clientName,
  value,
  onChange,
}) => {
  const [localLevel, setLocalLevel] = useState<string>('');
  const selectedLevel = value !== undefined ? value : localLevel;

  const { data: programMasterData, isLoading, isError } = useGetProgramMasterData();
  const energyLevel = programMasterData?.energyLevel;

  const nameDisplay = clientName ? `${clientName}'s` : 'their';
  const displayTitle = energyLevel?.title.replace('{{clientName}}', nameDisplay);

  // Use the API options and ensure they are sorted by order
  const options = [...(energyLevel?.options || [])].sort((a, b) => (a.order || 0) - (b.order || 0));

  const getIcon = (id: string) => iconMapping[id] || null;

  if (isLoading) {
    return <div className="energy-level-step">{'Loading options...'}</div>;
  }

  if (isError || !energyLevel) {
    return <div className="energy-level-step">E{'rror loading options.'}</div>;
  }

  return (
    <div className="energy-level-step">
      <h2 className="step-title">{displayTitle}</h2>
      <p className="step-subtitle">{energyLevel.subtitle}</p>

      <div className="energy-cards">
        {options.map((level) => (
          <button
            key={level.id}
            className={`energy-card ${selectedLevel === level.slug ? 'selected' : ''}`}
            onClick={() => {
              if (onChange) onChange(level.slug);
              setLocalLevel(level.slug);
              if (onNext) onNext();
            }}
          >
            <div className="icon-wrapper">{getIcon(level.id)}</div>
            <span className="level-label">{level.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
